import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const saltMinionRoutes: RouteObject[] = [
  {
    path: '/salt-minions',
    element: lazyElement(() => import('./Main')),
    handle: {
      documentTitle: 'Salt Minions',
      crumb: () => ({ label: 'Salt Minions', to: '/salt-minions' }),
    },
  },
  {
    path: '/salt-minions/view/:id',
    element: lazyElement(() => import('./View')),
    handle: {
      documentTitle: 'Salt Minion',
      crumb: () => ({ label: 'Salt Minion' })
    },
  },
];

export default saltMinionRoutes;
